import { toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./myToasts.scss";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle,
  FaInfoCircle,
  FaHourglassHalf,
} from "react-icons/fa";

import { BsInfoCircle } from "react-icons/bs";

const commonOptions = {
  position: "bottom-left",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  transition: Bounce,
};

const CloseButton = ({ closeToast }) => (
  <div onClick={closeToast} className="toast-close-button">
    ×
  </div>
);

const customToasts = {
  success: (message) => {
    toast.success(message, {
      ...commonOptions,
      icon: <FaCheckCircle size={24} />,
      className: "toast-common toast-success",
      closeButton: CloseButton,
    });
  },

  error: (message) => {
    toast.error(message, {
      ...commonOptions,
      icon: <FaTimesCircle size={24} />,
      className: "toast-common toast-error",
      closeButton: CloseButton,
    });
  },

  warning: (message) => {
    toast.warning(message, {
      ...commonOptions,
      icon: <FaExclamationTriangle size={24} />,
      className: "toast-common toast-warning",
      closeButton: CloseButton,
    });
  },

  info: (message) => {
    toast.info(message, {
      ...commonOptions,
      icon: <BsInfoCircle size={24} />,
      className: "toast-common toast-info",
      closeButton: CloseButton,
    });
  },

  pending: (message) => {
    return toast.info(message, {
      ...commonOptions,
      icon: <FaHourglassHalf size={24} />,
      className: "toast-common toast-pending",
      closeButton: CloseButton,
    });
  },

  promise: (promiseFunction, messages = {}, options = {}) => {
    const { isPasswordReset = false } = options;

    return toast.promise(
      promiseFunction,
      {
        pending: {
          render: messages.pending || "Loading...",
          className: "toast-common toast-pending",
        },
        success: {
          render({ data }) {
            if (typeof messages.success === "function") {
              return messages.success(data);
            }
            // Extract success message from various response formats
            const successMessage =
              data?.payload?.message || // Redux toolkit standard format
              data?.message || // Direct API response
              data?.data?.message || // Nested data response
              (typeof data === "string" ? data : null);

            return (
              messages.success || successMessage || "Completed successfully!"
            );
          },
          icon: <FaCheckCircle size={24} />,
          className: "toast-common toast-success",
        },
        error: {
          render({ data }) {
            console.log("Toast error data:", data); // Help with debugging
            
            if (typeof messages.error === "function") {
              return messages.error(data);
            }

            // Extract error message from various response formats
            const errorMessage =
              data?.payload?.message || // Redux toolkit format
              data?.response?.data?.message || // Axios error format
              data?.response?.data?.error || // Alternative API format
              data?.message || // Direct error message
              (typeof data === "string" ? data : null);

            // Special handling for password reset errors
            if (isPasswordReset && data?.response?.status === 400) {
              return "Check password and try again";
            }

            return messages.error || errorMessage || "An error occurred";
          },
          icon: <FaTimesCircle size={24} />,
          className: "toast-common toast-error",
        },
      },
      {
        ...commonOptions,
        closeButton: CloseButton,
      }
    );
  },

  loading: (message, toastId) => {
    return toast.loading(message, {
      ...commonOptions,
      toastId,
      className: "toast-common toast-pending",
      closeButton: CloseButton,
    });
  },

  dismiss: (toastId) => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  },
};

export default customToasts;
